module.exports = __webpack_public_path__ + "img/graphImg04.7caf9991.png";